var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.content.length
    ? _c(
        "div",
        { staticClass: "row" },
        [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("Tinybox", {
                staticStyle: { "z-index": "1021" },
                attrs: { images: _vm.content },
                model: {
                  value: _vm.index,
                  callback: function ($$v) {
                    _vm.index = $$v
                  },
                  expression: "index",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.images, function (image, index) {
            return _c("div", { key: index, staticClass: "col-md-4 mb-3" }, [
              _c("img", {
                staticClass: "img-fluid zoom",
                attrs: { src: _vm.path(image.path), loading: "lazy" },
                on: {
                  click: function ($event) {
                    return _vm.select(index)
                  },
                },
              }),
            ])
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }